import { getRegionBySeriesId } from '@mentimeter/region';
import { userCache } from '@mentimeter/user';

export const getRegion = (seriesId: string | undefined) => {
  // For unauthenticated users, userCache.region is undefined
  return (
    userCache.region || (seriesId ? getRegionBySeriesId(seriesId) : undefined)
  );
};
